'use client';

import { type TimeScalar } from '@bts-web/utils-formatting';
import {
  convertToLocaleDateString,
  timeScalarToDate,
} from '@bts-web/utils-formatting-client';
import { Locale } from '@bts-web/utils-lokalise';
import { useTranslation } from 'react-i18next';
import { InstantClockDisplayedText } from '../InstantClockDisplayedText/InstantClockDisplayedText.use-client';

type FormattedDateProps = {
  date: TimeScalar;
  locale: Locale;
  translationKey?: string;
  className?: string;
};

export const LocalizedDate = ({
  date,
  locale,
  translationKey,
  className,
}: FormattedDateProps) => {
  const { t } = useTranslation();

  const formatedDate = convertToLocaleDateString(date, locale);

  const formatedTime = timeScalarToDate(date).toLocaleTimeString(locale);

  if (translationKey) {
    return (
      <InstantClockDisplayedText className={className}>
        {t(translationKey, { date: formatedDate, time: formatedTime })}
      </InstantClockDisplayedText>
    );
  }

  return <span className={className}>{formatedDate}</span>;
};
